module.exports = __webpack_public_path__ + "static/media/form-checkbox-unchecked.6054df65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Checkbox/assets/form-checkbox-unchecked.svg
// module id = 2433
// module chunks = 193